<template>
  <el-dialog
    class="creDialog"
    width="900px"
    height="1000px"
    title="编辑内容"
    :visible.sync="showModal"
    :before-close="closeModal"
    ><div>
      <div style="width: 100%; display: flex; height: 55vh">
        <div
          style="
            width: 50%;
            height: 55vh;
            padding-right: 30px;
            overflow-y: auto;
          "
        >
          <t-form colon>
            <t-form-item label="用户"
              ><span>{{ comment.userName }}</span>
            </t-form-item>
            <t-form-item label="互动内容">
              <t-textarea
                disabled
                :autosize="{ minRows: 3, maxRows: 5 }"
                v-model="comment.message"
              ></t-textarea>
            </t-form-item>
            <t-form-item label="附件">
              <div>
                <div
                  v-for="(item, index) in comment.attachmentDtoList"
                  :key="index"
                  style="margin-top: 5px; margin-bottom: 5px"
                >
                  <div v-if="item.type == 'image'">
                    <div style="width: 200px">
                      <img
                        :src="item.url"
                        style="width: 100%; cursor: pointer"
                        @click="showImg(item.url)"
                      />
                    </div>
                  </div>
                  <div v-if="item.type == 'video'">
                    <div style="width: 200px">
                      <video width="200" height="160" controls>
                        <source :src="item.url" />
                        您的浏览器不支持 video 标签。
                      </video>
                    </div>
                  </div>
                </div>
                <span v-if="!comment.attachmentDtoList[0]">无</span>
              </div>
            </t-form-item>
            <t-form-item label="点赞数量"
              ><t-input placeholder="输入点赞数" v-model="comment.likeNum"
            /></t-form-item>
          </t-form>
        </div>
        <div class="dividerLine"></div>
        <div
          style="width: 50%; height: 47vh; padding-left: 30px; overflow-y: auto"
        >
          <div
            style="
              position: relative;
              padding-left: 30px;
              margin-bottom: 20px;
              padding-right: 10px;
            "
            v-for="(item, index) in reply"
            :key="index"
          >
            <div>
              <div>
                <div>
                  <span class="circle"></span
                  ><span style="margin-right: 10px; font-size: 14px">{{
                    item.userName
                  }}</span
                  ><span style="font-size: 12px" v-if="item.level"
                    >L{{ item.level }}</span
                  >
                </div>
                <div>
                  回复：<span>{{ comment.userName }}</span>
                </div>
                <div style="padding-left: 20px">{{ item.createdAt }}</div>
              </div>
              <div
                style="
                  position: absolute;
                  right: 10px;
                  top: 0;
                  cursor: pointer;
                  color: #556ee6;
                "
                @click="confirmDelete(item.id, index)"
              >
                删除
              </div>
            </div>
            <div>
              <t-textarea
                v-model="item.message"
                :autosize="{ minRows: 2, maxRows: 2 }"
                placeholder="请输入"
              ></t-textarea>
            </div>
          </div>
        </div>
      </div>
      <div class="flex-center" style="width: 100%; margin-top: 20px">
        <b-button
          class="btn-sm"
          variant="outline-primary"
          style="margin-right: 8px"
          @click="closeModal"
          >取消</b-button
        ><b-button
          class="btn-sm"
          style="margin-left: 8px"
          variant="primary"
          @click="saveComment"
          >确认</b-button
        >
      </div>
    </div>
  </el-dialog>
</template>
<script>
import groupApi from "@/server/api/group.js";
// import comments from "../../../../server/api/comments";
import comment from "@/server/api/comments";
export default {
  //   components: {},
  props: ["visible", "id"],
  model: {
    prop: "value",
    event: "change",
  },
  data() {
    return {
      showModal: true,
      reply: [],
      comment: {
        userName: "",
        attachmentDtoList: [],
      },
      replay: [],
    };
  },
  beforeMount() {
    console.log("加载了");
    this.getCommentDetail(this.id);
    this.getReplyList(this.id);
  },
  mounted() {},
  methods: {
    showImg(url) {
      this.ShowImg(url);
    },
    getCommentDetail(id) {
      groupApi.commentDetail({ id: id }).then((res) => {
        console.log("评论详情1", res);
        let obj = {};
        obj.userName = res.data.userName;
        obj.message = res.data.message;
        obj.attachmentDtoList = [];
        if (res.data.attachmentDtoList[0]) {
          obj.attachmentDtoList = res.data.attachmentDtoList;
        }
        obj.likeNum = res.data.likeNum;
        obj.id = res.data.id;
        this.comment = obj;
        // if (res.data.replyCommnets) {
        //   this.reply = res.data.replyCommnets;
        // }
        console.log("评论", this.comment);
      });
    },
    getReplyList(id) {
      comment.replys({ id: id }).then((res) => {
        console.log("回复列表", res);
        this.reply = res.data.items;
      });
    },
    confirmDelete(id, index) {
      this.confirm("确认删除该条回复？", () => {
        this.deleteComment(id, index);
      });
    },
    deleteComment(id, index) {
      let params = {};
      let arr = [];
      arr.push(id);
      params.ids = arr;
      groupApi.commentDelete(params).then((res) => {
        console.log("删除结果", res);
        if (res.code === 0) {
          this.success("删除成功！");
          this.reply.splice(index, 1);
        }
      });
    },
    saveComment() {
      let arr = [];
      let obj = {};
      obj.id = this.comment.id;
      obj.likeNum = Number(this.comment.likeNum);
      arr.push(obj);
      if (this.reply.length > 0) {
        this.reply.forEach((item) => {
          let obj1 = {};
          obj1.id = item.id;
          obj1.message = item.message;
          arr.push(obj1);
        });
      }
      let params = {
        comments: arr,
      };
      console.log("保存参数", arr);
      groupApi.commentUpdateBatch(arr).then((res) => {
        console.log("保存结果", res);
        if (res.code === 0) {
          this.success("保存成功！");
          this.closeModal();
        } else {
          this.warning(res.msg);
          console.log(res);
        }
      });
    },
    closeModal() {
      //   this.$emit("change", false);
      this.$emit("update:visible", false);
    },
  },
};
</script>
<style lang="scss" scoped>
.dividerLine {
  height: 100%;
  width: 1px;
  border: 1px solid #e7e7e7;
  border-width: 0 0 0 1px;
}
.circle {
  display: inline-block;
  background-color: #e7e7e7;
  width: 20px;
  height: 20px;
  border-radius: 50%;
  position: absolute;
  left: 0;
  top: 0;
}
</style>
